import { Injectable } from '@angular/core';
import { StarbaseComponentMessageServiceBase } from 'scaletech-core';
import { StarbaseNotificationService } from 'starbase-notification';
import { StarbaseModalDialogService } from 'starbase-modal-dialog';

@Injectable({
  providedIn: 'root'
})
export class StarbaseComponentMessageService extends StarbaseComponentMessageServiceBase {

  constructor(notiSvc: StarbaseNotificationService, modalSvc: StarbaseModalDialogService) {
    super(notiSvc, modalSvc);
  }
}
